const dictionaryES = {
  originalWriting: 'Español',
  general: {
    user: 'Usuario',
    email: 'Correo',
    password: 'Contraseña',
    close: 'Cerrar',
    save: 'Guardar',
    done: 'Listo',
    cancel: 'Cancelar',
    accept: 'Aceptar',
    decline: 'Declinar',
    cut: 'Cortar',
    browse: 'Buscar',
    chooseFileLabel: 'Elije archivo...',
    selectedCountLabel: 'archivos elegidos',
    from: 'desde',
    perDay: 'por día',
    select: 'Elige',
    owner: 'Propietario',
    details: 'Detalles',
    sizeList:[
      'Ninguno',
      'Pequeño',
      'Mediano',
      'Grande'
    ],
    options: 'Opciones',
    status: 'Estado',
    pay: 'Pagar',
    edit: 'Editar',
    from: 'Desde',
    to: 'Hasta',
    date: 'Fecha',
    place: 'Lugar',
    empty: 'Vacío',
    full: 'LLeno',
    go: 'Ir',
    uploadImagesLabel: 'Sube imágenes (Max %%)',
    uploadListLimitMessage: 'Elije %% imágenes para subir',
    back: 'Regresar',
    car: 'Auto',
    decide: 'Decidir',
    clear: 'Borrar',
    document: 'Documento',
  },
  user: {
    login: {
      title: 'Ingresar',
      userMailLabel: 'Usuario o E-mail',
      userMailPlaceHolder: 'Usuario o e-mail',
      userPasswordLabel: 'Contraseña',
      userPasswordPlaceholder: 'Contraseña',
      loginButtonLabel: 'Ingresar',
      newUserLabel: 'Registrarse',
      successfulLabel: 'Has ingresado'
    },
    reset: {
      titleDialog: 'Recuperación de contraseña olvidada',
      requestNewPassword: 'Recuperar Contraseña',
      generateNewPassword: 'Generar Nueva Contraseña',
      getKey: 'Tengo una clave',
      userResetTokenLabel: 'Clave Token de Reinicio ',
      userResetTokenPlaceholder: 'Clave token de reinicio',
      requestNewPasswordLabel: 'Solicitar Nueva',
      changePasswordLabel: 'Cambiar Contraseña',
      requestPasswordMessage: 'Si el correo electrónico ingresado se registró en nuestra base de datos, se envió un código a su bandeja de entrada',
      executePasswordMessage: 'La contraseña del usuario ha sido cambiada, puedes iniciar sesión ahora',
    },
    newAccount: {
      titleDialog: 'Registrar nuevo usuario',
      titleForm: 'Nuevo usuario',
      userNameLabel: 'Usuario',
      userNamePlaceHolder: 'Usuario (mínimo 8 carácteres)',
      userEmailLabel: 'E-mail',
      userEmailPlaceholder: 'E-mail',
      userPasswordLabel: 'Contraseña',
      userPasswordAllowedCharsMessage: 'Caracteres permitidos: Mayúsculas, minúsculas, numeros y @$!%*?&',
      userPasswordPlaceholder: 'Contraseña (mínimo 8 carácteres)',
      userPasswordConfirmLabel: 'Confirmar Contraseña',
      userPasswordConfirmPlaceHolder: 'Confirmar contraseña',
      userAgreementCheckbox: 'Acepto el acuerdo',
      userAgreementViewDoc: 'Ver acuerdo',
      userMissingFieldsMessage: 'Faltan algunos campos, por favor ingreselos.',
      userMinLengthMessage: 'El usuario debe tener al menos 8 caracteres.',
      userEmailValidMessage: 'Por favor, ingrese un email válido.',
      userPasswordValidationsMessage: 'La contraseña no es muy fuerte. Debe tener al menos 8 caracteres <br/> Debe tener al menos 1 letra minúscula.<br/>Debe tener al menos 1 mayúscula<br/>Debe tener un número.<br/>Debe tener al menos un caracter de estos: @$!%*?&',
      userPasswordMismatchMessage: 'La contraseñas no concuerdan.',
      userAcceptAgreementMessage: 'Debes haber leído y aceptar nuestro acuerdo.',
      userSuccesfullyCreatedMessage: 'El usuario ha sido creado. Por favor, revise su correo electrónico y habilate su cuenta.',
    },
    edit: {
      title: 'Editando Cuenta de Usuario',
      tabs: [
        'Cuenta Usuario',
        'Personal',
        'Ubicación',
        'Auto',
      ],
      account: {
        avatarSelection: 'Selección de ávatar',
        avatarUploadImage: 'Subir imagen',
        avatarSave: 'Guardar',
        uploadAvatarOkMessage: 'Imgan de ávatar actualizada',
        instructionsLabel: 'Instrucciones',
        instructionsStepOne: 'Elije un archivo para subir',
        instructionsStepTwo: 'Ajusta la imagen de la sección a tu gusto: mover, centrar, ampliar, etc',
        instructionsStepThree: 'Presiona el botón [Cortar] en la sección seleccionada; esa será tu imagen de avatar',
        instructionsStepFour: 'Presiona [Guardar] para agregar o actualizar tu imagen de avatar actual',
      },
      personal: {
        title: 'Información Personal',
        contactFullName: 'Nombre completo',
        contactFirstName: 'Nombre',
        contactLastName: 'Apellido',
        contactGenderLabel: 'Género',
        contactGenderMale: 'Masculino',
        contactGenderFemale: 'Femenino',
        contactGenderX: 'X',
        contactBirthDateLabel: 'Fecha nacimiento',
        contactNotAdultMessage: 'La edad ingresada no es la de un adulto (21)',
        contactSave: 'Guardar',
        viewLicense: 'Ver Licencia',
        licenseSave: 'Guardar Licencia',
        uploadLicenseLabel: 'Sube tu licencia de conducir (frente y reverso) (Max 2)',
        updateContactOkMessage: 'Contacto actualizado',
        uploadLicenseRequiredLengthFilesMessage: 'Selecciona las imágenes del frente y reverso de licencia de conducir',
        uploadLicenseFileOkMessage: 'Licencia de conducir actualizada',
      },
      location: {
        title: 'Dirección',
        addressLabel: 'Dirección completa',
        streetLabel: 'Calle',
        streetPlaceHolder: 'Nombre de la calle',
        externalNumber: 'Número Exterior',
        externalNumberPlaceHolder: 'Número exterior',
        district: 'Colonia',
        districtPlaceHolder: 'Colonia',
        zipCode: 'Código Postal',
        zipCodePlaceHolder: 'Código Postal',
        phone: 'Celular',
        phonePlaceHolder: 'Agregar tu número de celular',
        email: 'Correo',
        emailPlaceHolder: 'Agrega tu correo',
        province: 'Provincia',
        locality: 'Localidad',
        localityPlaceHolder: 'Localidad',
        addressSave: 'Guardar Dirección',
        updatedContactAdressMessage: 'La direción del contacto fue actualizada',
        currenteOwnerLocationLabel: 'El propietario se encuentra aproximadamente en',
      },
    },
  },
  home: {
    title: 'Inicio',
    panelLeft: {
      userLabel: 'Usuario',
      userNewAccountLabel: 'Nueva Cuenta',
      userResetPasswordLabel: 'Recuperar Contraseña',
      userEditAccountLabel: 'Editar Cuenta',
      item: 'Préstamos (Pruebas)',
    },
    panelRight: {
      userLabel: 'Usuario',
      userRegister: 'Registrar',
      sessionLabel: 'Sesión',
      sessionLogInLabel: 'Ingresar',
      sessionLogOutLabel: 'Salir',
      lightThemeLabel: 'Tema Claro',
      selectLanguageLabel: 'Idioma',
      sessionLogOutMessage: 'Ha cerrado sesión.',
      allowWebNotifications: 'Notificaciones (web)',
      notAllowedWebNotificationsMessage: 'Si no permites notificaciones, no recibrás alguna cuando te soliciten tu auto o cuando soliciten el tuyo',
    },
    topMenu: {
      offer: 'Ofertas',
      lend: 'Préstamos',
      howItWorks: '¿Como funciona?',
      contact: 'Contacto',
      notifications: 'Notificaciones',
    },
    main: {
      borrowCarLabel: 'Prestar un auto',
      sloganLabel: 'Juntos hacemos el mundo más sostenible.',
      whatCarsLabel: '¿Que autos hay disponibles?',
      location: 'Ubicación',
      date: 'Fecha',
      viewAvailabilityLabel: 'Ver Disponibilidad',
      flexible: 'Flexible',
      durable: 'Durable',
      transparent: 'Transparente',
      loanOfferLabel: 'Oferta de préstamos',
      enterLocationToSearch: 'Ingrese una ubicación a buscar',
      currentSelectedPlaces: 'Lugares seleccionados actualmente',
    },
  },
  car: {
    dashboard: {
      title: 'Panel',
      carList: 'Lista de autos',
      additionalData: 'Datos adicionales',
      aboutLender: 'Sobre el prestamista',
    },
    features: {
      titleShort: 'Caraterísticas',
      titleDialog: 'Elije características',
      isUsed: '¿Se usa?',
      name: 'Nombre',
      value: 'Valor',
    },
    restrictions: {
      titleShort: 'Restricciones',
      titleDialog: 'Elige Restricciones para el Auto',
    },
    penalties: {
      titleShort: 'Sanciones',
      titleDialog: 'Sanciones por Mal Uso',
    },
    edit: {
      title: 'Edición de Auto',
      useMyCarLabel: 'Prestar mí auto',
      manufacturerLabel: 'Marca',
      modelLabel: 'Modelo',
      yearLabel: 'Año',
      priceLabel: 'Precio',
      descriptionLabel: 'Descripción',
      carSave: 'Guardar Datos del Auto',
      carImageUploadLabel: 'Imagen del auto',
      carImageUploadSave: 'Subir Imagen del Auto',
      carPlateUploadLabel: 'Placas',
      carPlateUploadSave: 'Subir Placas',
      carFeatureLabel: 'Características del Auto',
      carUseRestrictionLabel: 'Restricciones de Uso del Auto',
      carImagesPhotoBrowserLabel: 'Ver Imágenes del Auto',
      carImageFileListLabel: 'Subir Lista de Imágenes',
      uploadCarImagesLabel: 'Sube las imágenes de tu auto (Max 6)',
      updatedCarMessage: 'Datos del auto actualizados',
      selectFileToUpload: 'Elije un archivo a subir',
      carImageUploadedOkMessage: 'Imagen del auto subida',
      carPlateUploadedOkMessage:'Placa del auto subida',
      uploadCarImagesLimitMessage: 'Debes elegir 6 imágenes de tu carro',
      carImageListUploadedOkMessage: 'Lista de imágenes de tu auto subidas',
      carIsUsedStatusMessage: 'El carro esta en un prestamo actualmente, no puede ser actualizado ahora',
      carSize: 'Tamaño de auto',
      carEstimatedPrice: 'Valor Estimado del Auto',
      suggestedLoanPrice: 'Precio de Préstamo Sugerido',
      carMinPrice: 'Valor Mínimo del Auto',
      carMaxPrice: 'Valor Máximo del Auto',
      minRecommendedPrice: 'Precio Mínimo Sugerido',
      maxRecommendedPrice: 'Precio Máximo Sugerido',
      checkSizeMessage: 'Seleccione un tamaño para sugerir un precio',
      //recommendedPriceMessage: 'El precio debe estar entre %% y %%, precio actual: %%',
      recommendedPriceMessage: 'Ajuste el precio diario de su coche [%%] entre [€%%] y [€%%] para mantenerlo atractivo para los arrendatarios',
      licensePlate: "Matrícula",
      selectRestrictedDateLabel: 'Selecciona Fechas Restringidas',
      selectRestrictedDatePlaceholder: 'Selecciona Fechas Restringidas',
      saveRestrictedDates: 'Guardar Fechas',
      selectRestrictedDates: 'Seleccionar Fechas',
      deleteAllRestrictedDates: 'Borrar Todas Las Fechas',
      errorRestrictedDate: 'Elige algunas fechas para no prestar tu auto',
      messageRestrictedDate: 'Fechas restringidas guardadas para este auto',
      confirmDeleteRestrictedDate:'¿Quieres borrar todas las fechas restringidas de tu auto?',
      messageDeletedRestrictedDate:'Todas las fechas restrinigidas de este auto han sido borradas',
      carPreferredDeliveryTime: 'Hora Preferida de Entrega',
      carPreferredReturnTime: 'Hora Preferida de Regreso',
      penaltiesForMisusing: 'Sanciones por Mal Uso',
    },
  },
  loan: {
    title: 'Préstamo',
    lends: 'Prestamos',
    borrows: 'Solicitudes',
    tabs: [
      'Solicitud',
      'Decisión',
      'Pago',
      //'Aseguranza',
      'Cita',
      'Encuentro',
      'Detener',
      'Regresar',
      'Calificar',
      'Incidencias',
    ],
    dashboard: {
      carLoanTag: 'Etiqueta',
      lender: 'Prestador',
      borrower: 'Solicitante',
      startDate: 'Fecha Inicio',
      endDate: 'Fecha Entrega',
      daysToBorrow: 'Días a Prestar',
      totalToPay: 'Total a Pagar',
      discounts: 'Descuentos',
      isGoingAbroad: '¿Va al extrajero?',
      returningKilometers: 'Kms al Regreso',
      currentKilometers: 'Kms Actualmente',
      pricePerDay: 'Precio por Día',
    },
    request: {
      loanPeriod: 'Período de Préstamo',
      loanRangeDatePlaceHolder: 'Elije período de préstamo',
      onlyDriver: 'Solo un conductor(a)',
      driveAbroad: '¿Viajarás al extrajero? (+€1 por día)',
      extraDriverData: 'Conductor Extra',
      messageRangeDate: 'Elije un rango de fechas que viajarás',
      onEmptyFormField: 'Por favor ingrese el campo: [ %% ] del copiloto',
      confirmSaveRequest: 'Por favor, añade tu contraseña para confirmar que aceptas solicitar este coche.',
      messageSavedRequest: 'El prestamista necesita aceptar tu petición',
      onLoanPeriodAtLeast3Days: 'El período de préstamo debe ser establecido en al menos 3 días a partir de hoy',
      onLoadPeriodGreater30Days: 'El plazo del préstamo no puede ser superior a 30 días',
      loanPeriodStartTime: 'Elije hora de inicio del prestamo',
      loanPeriodEndTime: 'Elije hora de fin del prestamo',
      buyoutDeposit: 'Depósito de compra',
      buyoutDepositOption: 'Elije una opción de depósito de compra',
      messageOngoingDates:'Este auto tiene algunas fechas reservadas para ser usado, elija algunas fechas sin uso',
      messageRestrictedDates:'Este auto tiene algunas fechas restringidas para ser usado, elija algunas fechas sin uso',
      aboutCarOwner: 'Acerca de su propietario',
      userRatingLabel: 'Calificación del usuario',
      invoice: {
        title: 'Pago Total',
        details: 'Detalles de la Factura',
        basePrice: 'Precio €%% por %% días',
        depositFee: 'Tarifa por Depósito',
        depositToPay: 'Depósito a Pagar',
        daysToBorrow: 'Días a Prestar',
        weeksToBorrow: 'Semanas a Prestar',
        discountPercent: 'Descuento %%%',
        totalDiscount: 'Descuento Total',
        daysToGoAbroad: 'Días en el Extranjero',
        weekendSurcharge: 'Fin Semana %%%',
        holidaySurcharge: 'Recargo por Festividad',
        serviceFee: 'Tarifa por Servicio',
        administrativeFee: 'Tarifa Administrativa',
        underAgeRate: 'Under Age Rate',
        subtotal: 'Subtotal',
        taxes: 'Impuestos',
        totalToPay: 'Total a Pagar',
      },
    },
    deciding: {
      confirmCancel: '¿Quieres CANCELAR el préstamo de este coche?',
      messageCancel: 'El prestamista se ha negado a prestar el coche. Cancelando operaciones...',
      confirmAccept: '¿Quisieras aceptar el prestar tu vehículo?',
      messageAccept: 'Se requiere depósito de una póliza de seguro.',
      hasDecided: 'ha decidido solicitar tu auto',
      loanInfo: 'Información del préstamo',
      yourEarnings: 'Tus ganancias',
    },
    payment: {
      title: 'Su préstamo está casi listo, por favor proceda a pagar para continuar',
      goPay: 'Proceder a pagar',
      popupTitle: 'Su pago',
      messageStripePaymentStatus: 'Su pago fue %%',
      confirmCancel: '¿Quieres CANCELAR el pago de este coche?',
      messageCancel: 'El solicitante ha declinado a pagar el coche. Cancelando operaciones...',
      messageAfterSucceded: 'Al prestador se le notificado que ahora tiene que preparar el seguro y tu debes esperar una cita para continuar',
    },
    appointment: {
      labelData: 'Datos de la cita',
      pleaseNote: 'Por favor tenga en cuenta que',
      notRenting: 'De LeenAuto no es de alquiler, sino de solicitud y préstamo, para que contratar el seguro externo se realice sin problemas ',
      noLawIssues: 'Además, el Prestatario ha sido debidamente examinado para asegurar que no ha tenido contactos con la justicia y/o lo ha declarado, y que el Prestatario también ha declarado cumplir con los Términos y Condiciones Generales de DeLeenAuto',
      agreedOnRequirements: 'Finalmente, la declaración, los requisitos y todas las condiciones del seguro externo coinciden con los Términos y Condiciones Generales de DeLeenAuto',
      insuranceFrom: 'De LeenAuto recomienda gestionar esto a través de',
      insuranceHasBeenAdded: 'He añadido un seguro a mi coche',
      selectAppointmentDate: 'Seleccione una fecha para reunirse con su solicitante',
      selectAppointmentPlace: 'Seleccione un lugar para reunirse con su solicitante',
      confirmAddedInsurance: 'Confirme que ha agregado un seguro',
      noAppointmentSelected :'La feche de la cita no fue seleccionada',
      noPlaceEntered: 'Ingrese un lugar',
      confirmMeeting:'¿Quisiera citarse con su prestatario el día %% en %%?',
      messageMeeting: 'El prestatario será notificado para verse con ud. el día %% en %%',
    },
    meeting: {
      uploadCarLoanImagesLabel: 'Subir imagenes actuales del auto (Max 8)',
      uploadDriverImagesLabel: 'Subir licencias de conductores (dueño, solicitante + extra) (Max 7)',
      currentFuelLevel: 'Nivel de combustible actual',
      currentKilometers: 'Kilómetros actuales',
      imageListLimitMessage: 'Elije %% imágenes para subir',
      confirmStartLoan: '¿Quisiera empezar el préstamo?',
      confirmEndLoan: '¿Quisiera finalizar el préstamo?',
      showCarImageLabel: 'Foto de auto',
      showDriverImageLabel: 'Fotos de conductores',
      emptyTank: 'El combustible no debe estar vacío',
      kilometersBelowOne: 'Los kilómetros no deben ser menor a cero o vacío',
    },
    backAppointment: {
      selectAppointmentDate: 'Seleccione una fecha para reunirse con su prestador',
      selectAppointmentPlace: 'Seleccione un lugar para reunirse con su prestador',
      confirmMeeting:'¿Quisiera citarse con su prestador el día %% en %%?',
      messageMeeting: 'El prestador será notificado para verse con ud. el día %% en %%',
    },
    issue: {
      checkLabel: '¿Tuviste algun problema?',
      description: 'Describe tu problema',
      placeholder: '¿Algún problema?',
      descriptionTooLong: 'La descripción es muy larga',
      askCreateIssue: '¿Quisieras crear una incidencia?',
      newIssueCreated: 'Incidencia creada',
      askCloseLoan: '¿Quieres cerrar tu préstamo como "Satisfactorio"?',
      closedLoanSuccess: 'Préstamo cerrado exitosamente',
      tagMarkedIssues: 'Mark all issues you had',
      buttonProceed: 'Proceeder a Evaluaar Problema',
      noIssueSelected: 'Ningun problema fue elegido',
      askProceedIssue: '¿Quisieras proceder con tu problema?',
    },
    rating: {
      yourRatingLabel: 'Tu calificación',
      yourFeedbackLabel: 'Tus comentarios',
      sendFeedback: 'Enviar comentarios',
      textPlaceHolder: 'Agregue su comentario',
      chooseStarMessage:'Elija una estrella para evaluar',
      editorMessage: 'Por favor ingrese un comentario',
      afterSaveMessage: 'Sus comentarios han sido agregados',
      starLabel: 'Calificación del %%',   /* User:lender or borrower rating */
      userLabel: 'Comentarios del %%', /* User:lender or borrower feedback */
    },
    statusLabel: {
      1: 'Solicitado',
      2: 'Aceptado',
      3: 'Pagado',
      4: 'Reunión Acordada',
      5: 'Prestado',
      6: 'Retorno Acordado',
      7: 'Devuelto',
      8: 'Finalizado',
      9: '--Reservado--',
      10: 'Finalizado con problemas',
      11: '--Reservado--',
      12: 'Cancelado por Prestador',
      13: 'Cancelado por Solicitante',
    },
    signImage: {
      title: 'Agregue su firma para confirmar la aceptación del préstamo de automóvil',
      noSignMessage: 'Ninguna firma fue escrita, por favor agregue una',
    },
  },
  admin: {
    title: 'Panel de Control',
    sections: {
      carPricing: 'Establecimiento de Precios',
      carPricingEdit: 'Edicion de Precio',
      carLoanGrid: 'Préstamos Abiertos',
      buyoutDeposit: {
        adminButton: 'Compra de Depósitos',
        panelTitle: 'Opciones de Depósitos',
        editTitle: 'Edición de Depósitos',
        feeLabel: 'Tarifa de Depósito',
        toPayLabel: 'Depósito por Pagar',
        displayMessageLabel: 'Mensaje a Mostrar en Selección',
        showOptionLabel: 'Mostrar opción en la lista de selección',
        messageNoEdited: 'Esta opción no puede ser editada',
      },
      refund: {
        adminButton: 'Reembolsos',
        panelTitle: 'Autos Prestados con Problemas',
        loanTag: 'Etiqueta',
        edit:{
          tagLoan: 'Etiqueta / Fecha Inicio / Fecha Fin',
          tagUsers: 'Prestador / Prestatario',
          tagFuel: 'Combustible al inicio / Combustible al regreso',
          tagPlace: 'Lugar de entrega / Lugar de regresa',
          tagDate: 'Fecha de entrega / Fecha de regreso',
          tagOdometer: 'Odómetro al inicio / Odómetro al regreso',
          tagIssueComment: 'Comentarios',
          tagIssueImages: 'Imagenes de Prueba',
          tagMarkedIssues: 'Problemas que el usuario tuvo',
          tagCancelIssue: '¿Desea cancelar este reembolso?',
          tagCancelMessage: 'Este problema ha sido cancelado',
          tagAcceptIssue: '¿Quieres proceder con el reembolso?',
          tagAcceptMessage: 'Este problema ha sido aprobado para ser reembolsado, proceda como quiera, no tengo idea.',
        },
      },
    },
  },
  googleMap: {
    dialog: {
      title: 'Buscar',
      inputTitle: 'Buscar una dirección',
      inputPlaceHolder: 'Ingresa una ubicación ...',
    },
  },
  document: {
    borrowerDetails: 'Parte I: Detalles del Prestatario/Conductor',
    extraDriverDetails: 'Opcional: Detalles del Conductor Extra',
    lenderDetails: 'Parte II: Detalles del Prestador',
    rentailPeriodDetails: 'Detalles del Período de Renta',
    carDetails: 'Detalles del Auto',
    allowedProhibitedActions: 'Acciones Permitidas & Prohíbidas',
    contractSigning: 'Firma del Contrato',
    partBorrower: 'Parte I: Prestatario',
    partLender: 'Parte II: Prestador',
    pickUpTime: 'Hora de Entrega',
    returnTime: 'Hora de Regreso',
    locationPickReturn: 'Lugar de Entrega y Regreso',
  },
};

export default dictionaryES;
